import _objectSpread from'@babel/runtime/helpers/objectSpread2';import _defineProperty from'@babel/runtime/helpers/defineProperty';import _slicedToArray from'@babel/runtime/helpers/slicedToArray';import {useCallback}from'react';import {useIntl}from'react-intl';import {REALMS,normalizeRealm}from'../utils/realmUtils.js';import {APP_LANGS}from'../translations/index.js';import useRealm from'./useRealm.js';import useQueryParams,{QUERY_PARAMS}from'./useQueryParams.js';import'url-search-params-polyfill';import useCIAMContextParam from'./useCIAMContextParam.js';function buildAppAwarePath(path) {
  var realm = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : REALMS.CUSTOMER;
  var normalizedRealm = normalizeRealm(realm);
  if (normalizedRealm === REALMS.CUSTOMER) {
    return "".concat(path);
  }
  return "/".concat(normalizedRealm).concat(path);
}
function buildPathSearchParams(path) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : APP_LANGS.EN_CA;
  var searchParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var urlSearchParams = new URLSearchParams();
  urlSearchParams.set('ui_locales', locale);
  Object.entries(searchParams).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      name = _ref2[0],
      value = _ref2[1];
    if (value) {
      urlSearchParams.set(name, value);
    }
  });
  return "".concat(path, "?").concat(urlSearchParams.toString());
}
function usePathBuilder() {
  var currentRealm = useRealm();
  var intl = useIntl();
  var _useQueryParams = useQueryParams(),
    goTo = _useQueryParams[QUERY_PARAMS.GO_TO];
  var brand = useCIAMContextParam('brand');
  return useCallback(function (path) {
    var useSearchParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var _ref3 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref3$realm = _ref3.realm,
      realm = _ref3$realm === void 0 ? currentRealm : _ref3$realm,
      _ref3$locale = _ref3.locale,
      locale = _ref3$locale === void 0 ? intl.locale : _ref3$locale,
      _ref3$searchParams = _ref3.searchParams,
      searchParams = _ref3$searchParams === void 0 ? {} : _ref3$searchParams;
    var appAwarePath = buildAppAwarePath(path, realm);
    if (useSearchParams) {
      var _carryForward;
      var isRealmSame = currentRealm === realm;
      var carryForward = (_carryForward = {}, _defineProperty(_carryForward, QUERY_PARAMS.GO_TO, isRealmSame ? goTo : undefined), _defineProperty(_carryForward, "brand", isRealmSame ? brand : undefined), _carryForward);
      return buildPathSearchParams(appAwarePath, locale, _objectSpread(_objectSpread({}, carryForward), searchParams));
    }
    return appAwarePath;
  }, [currentRealm, intl, goTo, brand]);
}export{usePathBuilder as default};